import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/no-image2.png'


const _withScopeId = n => (_pushScopeId("data-v-7002dce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "club-voucher-page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "product-img-block" }
const _hoisted_5 = {
  key: 1,
  class: "default-img",
  src: _imports_0
}
const _hoisted_6 = { class: "row-name single-ellipsis" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTitleWithSearch = _resolveComponent("HeaderTitleWithSearch")!
  const _component_LazyImage = _resolveComponent("LazyImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitleWithSearch, {
      title: _ctx.$t('label.clubs'),
      rows: _ctx.businessClients,
      onOnSelect: _ctx.onSelectClub,
      onChangeSearchText: _ctx.changeSearchText
    }, null, 8, ["title", "rows", "onOnSelect", "onChangeSearchText"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["row-item", { 'row-item-selected': _ctx.clubId == row.id }]),
          onClick: ($event: any) => (_ctx.onSelectClub(row.id)),
          key: row.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            (row.companyLogoUrl)
              ? (_openBlock(), _createBlock(_component_LazyImage, {
                  key: 0,
                  src: row.companyLogoUrl,
                  "src-placeholder": require('../assets/images/no-image2.png')
                }, null, 8, ["src", "src-placeholder"]))
              : (_openBlock(), _createElementBlock("img", _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(row.name), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, [
        _hoisted_8,
        _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.back")), 1)
      ])
    ])
  ]))
}